import { DialogAwareContentContainer, DialogContent } from "@/components/shared";
import { ExitLockFeedbackForm } from "./ExitLockFeedbackForm";
import { useEffect, useRef } from "react";
import { PostHogEvent } from "@/posthog/posthog-capture-names";
import { PosthogHelper } from "@/posthog/posthog-helper";
import type { ExitLockCapturedParams } from "./exit-lock-capture-params.type";
import { BREAKPOINTS } from "@/config/breakpoints.config";

export type ExitFeedbackDialogProps = {
    exitLockCaptureParams: ExitLockCapturedParams;
};

export const ExitLockFeedbackDialog = ({ exitLockCaptureParams }: ExitFeedbackDialogProps) => {
    const mounted = useRef(false);

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true;
            // Dialog opened
            PosthogHelper.capture({
                event_name: PostHogEvent.ExitLockFeedbackDialog.opened,
                properties: exitLockCaptureParams,
                userIdentifier: exitLockCaptureParams.userAddress,
                allowTemporaryOptIn: false,
            });
        }
    }, []);

    return (
        <DialogContent
            style={{
                maxWidth: BREAKPOINTS.sm,
                minWidth: BREAKPOINTS.xs,
                // width: BREAKPOINTS.sm,
            }}
        >
            <DialogAwareContentContainer isDialog>
                <ExitLockFeedbackForm exitLockCaptureParams={exitLockCaptureParams} />
            </DialogAwareContentContainer>
        </DialogContent>
    );
};
